<template>
  <div class="vacancy-list-detail-item">
    <div class="vacancy-list-detail-item__title" @click="showVacancy">
      <RouterLink :to="showVacancy()">
        {{ vacancy.title }}
      </RouterLink>
    </div>
    <div class="vacancy-list-detail-item__item">
      <VacancySalary short :salary="vacancy.salary" class="vacancy-list-detail__value" />
    </div>
    <div v-if="vacancy.address" class="vacancy-list-detail-item__item order-last order-sm-3">
      <span class="vacancy-list-detail-item__value vacancy-list-detail-item__value_address">{{ vacancy.address.address }}</span>
    </div>
    <div class="vacancy-list-detail-item__item">
      <VacancyExperience :experience="vacancy.experience" class="vacancy-list-detail-item__value" />
    </div>
    <div class="vacancy-list-detail-item__item">
      <VacancyEmployment :employment="vacancy.employment" :schedule="vacancy.schedule" class="vacancy-list-detail-item__value" />
    </div>
  </div>
</template>

<script>
import VacancyExperience from './VacancyExperience.vue';
import VacancyEmployment from './VacancyEmployment.vue';
import VacancySalary from '../Vacancy/VacancySalary.vue';

export default {
  name: 'VacancyItem',
  components: { VacancySalary, VacancyEmployment, VacancyExperience },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showVacancy() {
      return {
        name: 'vacancy',
        params: { companyId: this.vacancy.companyId, vacancyId: this.vacancy.id },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .vacancy-list-detail-item {
    width: 100%;
    max-width: 32.25rem;
    padding: 1.5rem 0;
    border-top: 1px solid #EEEEEE;
    &:first-child {
      border: none;
    }
    &__item {
       display: flex;
       justify-content: space-between;
       align-items: flex-end;
       position: relative;
       color: #212121;
       font-weight: 400;
       font-size: 0.875rem;
       line-height: 1.43;
    &:after {
       content: '';
       background: url("../../assets/img/list-item-bg.svg") center;
       width: 100%;
       height: 1px;
       min-height: 1px;
       position: absolute;
       left: 0;
       bottom: 0.375rem;
       z-index: 1;
     }
    }
    &__title {
       font-size: 1.125rem;
       line-height: 1.11;
       font-weight: 400;
       color: #0A82D9;
       margin-bottom: 1.25rem;
      a {
        text-decoration: none;
      }
     }
    &__caption {
       background: #FFFFFF;
       position: relative;
       z-index: 2;
     }
    &__value {
       text-align: right;
       background: #FFFFFF;
       position: relative;
       z-index: 2;
       margin-left: 1.25rem;
     }
    }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .vacancy-list-detail-item {
      padding: 1.25rem 0;
    }
  }

  .vacancy-list-detail-item {
    display: flex;
    flex-direction: column;
    padding: 1rem 0 0.75rem;
    &__item {
      line-height: 1;
      justify-content: flex-start;
      margin-bottom: 0.375rem;
    &:after {
       content: none;
     }
    }
    &__title {
       font-size: 1rem;
       margin-bottom: 1rem;
     }
    &__caption_experience:after {
      content: ':';
      display: inline-block;
      vertical-align: middle;
      margin-right: 0.25rem;
    }
    &__value {
       text-align: left;
       margin-left: 0;
      &_address {
        font-size: 0.8125rem;
        line-height: 1.3;
        color: #757575;
        padding-top: 0.5rem;
      }
     }
}
</style>

<i18n locale="en" lang="yaml">
salary: Salary
address: Address
experience: Experience
employment: Type of employment
show: View page
</i18n>

<i18n locale="ru" lang="yaml">
salary: Зарплата
address: Адрес
experience: Опыт работы
employment: Занятость
show: Просмотреть страницу
</i18n>
